import { AnalyticsEvent } from '../models';

export class SummerExtrasErrorEvent implements AnalyticsEvent {
    name = 'SummerExtrasErrorEvent';

    constructor(public readonly errorMessage: string = "We're having some trouble getting your challenge progress.") { }
}
